export default __webpack_public_path__ + "static/media/cphgamelab_Logo_Black.99fadcc7.svg";